import BaseCasePage from 'client/common/pages/solution';

import './index.css';

export default BaseCasePage;
